module.exports = __webpack_public_path__ + "static/img/title2.49df6e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/yxds2021/title2.png
// module id = n2Uf
// module chunks = 0